var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34 23.9995C34 24.4226 33.6538 24.7688 33.2308 24.7688H24.7692V33.2303C24.7692 33.6555 24.4252 34 24 34C23.5748 34 23.2308 33.6534 23.2308 33.2303V24.7688H14.7692C14.344 24.7688 14 24.425 14 24C14 23.5764 14.3442 23.2303 14.7692 23.2303H23.2308V14.7688C23.2308 14.3436 23.5748 14 24 14C24.4252 14 24.7692 14.3438 24.7692 14.7688V23.2303H33.2308C33.6538 23.2303 34 23.5764 34 23.9995Z",
    fill: "#3ECF8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    stroke: "#3ECF8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewAccount);
export default __webpack_public_path__ + "static/media/addNewAccount.4fa8bd0b5fe4831ed871b674a0c874dd.svg";
export { ForwardRef as ReactComponent };